module.exports = __webpack_public_path__ + "static/media/imagemPE.cabc5a9b.png";